<app-wide-alert-component></app-wide-alert-component>
<router-outlet></router-outlet>